import { useMarketplaceContext } from 'src/contexts/marketplace';
import { Text } from '@chakra-ui/react';
import { Listing } from 'src/api/v1-api';
import { calculateTimeSince } from 'src/utils/timeUtils';

interface DateSinceAddedProps {
  listing: Listing;
}

const DateSinceAdded = ({ listing }: DateSinceAddedProps): JSX.Element => {
  const { marketplace } = useMarketplaceContext();
  const SourceToListedVerb = marketplace?.functional?.source_to_listed_verb || {};

  if (listing?.created_at) {
    let timeSinceListed = calculateTimeSince(listing?.listed_at ?? listing.created_at);
    if (listing?.source && SourceToListedVerb[listing?.source]) {
      timeSinceListed = `${SourceToListedVerb[listing.source]} ${timeSinceListed}`;
    }
    return (
      <Text fontSize="0.7rem" color="gray.600">
        {timeSinceListed}
      </Text>
    );
  }
  return <></>;
};

export default DateSinceAdded;
